<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="counselingData"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Counseling - Activity</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <export-list />
          <v-spacer></v-spacer>
          <v-row>
            <v-col class="col--padding" md="4">
              <v-btn
                @click="displayCurrentRoute"
                color="teal accent-4"
                depressed
                dark
                class="mt-1 ml-3"
              >
                <v-icon left dark>mdi-filter-variant</v-icon>View All
              </v-btn>
            </v-col>
            <v-col class="col--padding" lg="8">
              <v-select
                class="mr-3"
                v-model="townshipId"
                placeholder="choose township..."
                hide-details
                outlined
                dense
                item-text="name"
                item-value="id"
                @change="getActivityByTwn"
                :items="townships"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.mdrtb_code }}</td>
          <td>{{ item.mdrtb_year }}</td>
          <td v-if="item.mdrtb_monopoly == 1">No</td>
          <td v-else-if="item.mdrtb_monopoly == 2">Yes</td>
          <td v-else-if="item.mdrtb_monopoly == 3">SG</td>
          <td v-else-if="item.mdrtb_monopoly == 4">MGY</td>
          <td v-else-if="item.mdrtb_monopoly == 5">TGI</td>
          <td v-else>--</td>
          <td>{{ item.date }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.month }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.township.name }}</td>
          <td>
            <span
              :class="{
                'red accent-3': item.comments.length === 0,
                'green accent-3': item.comments.length != 0,
              }"
              class="px-3 py-1 white--text font-weight-bold"
            >
              {{ item.comments.length }}
            </span>
          </td>
          <td>
            {{ item.checked === 1 ? "Yes" : "No" }}
          </td>
          <td>
            <div class="mr-2">
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ExportList from "./exportList.vue";

export default {
  props: {
    counselingData: {
      type: Array,
    },
  },
  components: {
    ExportList,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    townshipId: null,
    headers: [
      { text: "No", value: "no" },
      { text: "MDRTB Code", value: "mdrtb_code" },
      { text: "MDRTB Year", value: "mdrtb_year" },
      { text: "Mono-poly", value: "monopoly" },
      { text: "Date", value: "date" },
      { text: "phone", value: "phone" },
      { text: "Month", value: "month" },
      { text: "Year", value: "year" },
      { text: "Township", value: "township" },
      { text: "Feedbacks", value: "comments" },
      { text: "Checked", value: "checked" },
      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["townships"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
  },
  methods: {
    displayCurrentRoute() {
      this.$router.push({
        path: this.$route.currentRoute,
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
      this.$router.go();
    },
    getActivityByTwn(townshipId) {
      this.$router.push({
        path: this.$route.currentRoute,
        query: { township: townshipId },
      });
      this.$store.dispatch("Counseling/getAll", {
        month: this.$route.params.month,
        year: this.$route.params.year,
        township_id: this.$route.query.township,
      });
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "edit-counseling",
        params: {
          id: convertNumber,
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
    },
  },
};
</script>

<style scoped></style>
